<template>
  <v-container fill-height class="login-container">
    <v-layout justify-center column fill-height>
      <v-flex text-xs-center>
        <img v-if="$domain == $hwUrl" draggable="false" :src="require('@/assets/logo_pic_herdwatch.svg')" alt="logo" style='width:20%;' contain>
        <img draggable="false" :src="$domain == $hwUrl ? require('@/assets/login_logo_herdwatch.svg') : require('@/assets/login_logo.png')" alt="logo" class="login-logo" contain>
      </v-flex>
      <!-- <v-flex text-xs-left class="headline font-weight-bold">MOONSYST</v-flex>    -->
      <v-flex>
      <v-layout v-if="!register" justify-center column fill-height>
      <form>
      <v-flex>
          <InputAutofill
            :submitFunction="login"
            :label="$t('account.email')"
            v-model="email"
            autofocus
            autocomplete="email"
            type="text"
          />
          <br>
          <InputAutofill
            :submitFunction="login"
            :label="$t('account.password')"
            v-model="password"
            autocomplete="current-password"
            type="password"
          />
          <br>
          <div class="danger-alert" v-html="error">{{error}}</div>
          <br>
          <v-btn
            dark
            block
            large
            class="secondary login-button"
            @click="login">
            <div class="font-weight-bold text-capitalize">{{$t('account.logIn')}}</div>
          </v-btn>
          <v-btn
            v-if="$domain != $hwUrl"
            dark
            block
            large
            class="accent login-button"
            @click="register = true">
            <div class="font-weight-bold text-capitalize">{{$t('account.register')}}</div>
          </v-btn>
      </v-flex>
      </form>
      </v-layout>
      </v-flex>
    <register v-on:login="register = false" v-if="register"></register>

    </v-layout>
  </v-container>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import Register from '@/components/Register'
import InputAutofill from "@/components/InputAutofill.vue";
import { RoleTypes } from '@/constants/role_types';

export default {
  components: {
    Register,
    InputAutofill
  },
  data () {
    return {
      email: '',
      password: '',
      error: null,
      register: false
    }
  },
  methods: {
    async login () {
      try {
        const response = await AuthenticationService.login({
          username: this.email,
          password: this.password,
          details: true
        })

        if(!response || response.status !== 200) {
          this.error = response.data;
          return;
        }

        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', {...response.data.user, username: response.data.username})
        this.$moment.tz.setDefault(response.data.user.timezone)
        this.redirect()
      } catch (error) {
        this.error = error.response.data.error.message
      }
    },
    redirect () {
      if (typeof (this.$store.state.user) !== 'undefined' && this.$store.state.user && this.$store.state.user.role_type) {
        if([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin, RoleTypes.CompanyUserVeterinarian, RoleTypes.CompanyUserShiftLeader].includes(this.$store.state.user.role_type)) {
          // Sneaky solution to change back background color from login screen
          if(this.$domain == this.$hwUrl) {
            document.getElementById('Moonsyst').classList.remove('bg-login')
          }
          this.$router.push({name: 'dashboard'})
        }
      }
    }
  },
  async mounted () {
    // Check if user is already logged in and redirect to dashboard
    if (this.$store.state.isUserLoggedIn) {
      this.$router.push({name: 'dashboard'})
      return
    }
    
    // Sneaky solution to change background color for login screen
    if(this.$domain == this.$hwUrl) {
      document.getElementById('Moonsyst').classList.add('bg-login')
    }
  }
}
</script>

<style scoped>

@media only screen and (min-width: 768px){
  .login-container {
    min-width: 440px;
    max-width: 20%
  }
}
.login-logo {
  text-align: left;
  padding-right: 34px;
  width: 100%;
  margin-bottom:3em;
}
.login-button {
  border-radius: 0px;
}
.layout.column>.flex {
  flex-grow: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue